import * as React from 'react';
import styled from 'react-emotion';

interface ISelectWrapperProps {
  size?: string;
}

const SelectWrapper = styled('div')`
  font-size: ${(props: ISelectWrapperProps) => props.size || '1rem'};
  position: relative;
  &::after {
    position: absolute;
    top: calc(50% - 0.25em);
    right: 1em;
    content: '';
    border-top: 0.5em solid black;
    border-right: 0.5em solid transparent;
    border-bottom: 0.5em solid transparent;
    border-left: 0.5em solid transparent;
    pointer-events: none;
  }
`;

interface ISelectInputProps {
  bg?: string;
  borderColor?: string;
  disabled?: boolean;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
}

const SelectInput = styled('select')`
  position: relative;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  line-height: inherit;
  appearance: none;
  min-width: 12em;
  width: 100%;
  background-color: ${(props: ISelectInputProps) => props.bg || 'transparent'};
  margin: 0;
  padding: 0.25em 0.5em;
  border-radius: 12px;
  border: 2px solid ${props => props.borderColor || 'black'};
  padding: 0.5em;
  transition: opacity 250ms ease-in-out;
  &:disabled {
    opacity: 0.25;
    pointer-events: none;
  }
  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px rgb(49, 68, 150);
  }
`;

SelectInput.displayName = 'SelectInput';

export const Select: React.SFC<ISelectInputProps & ISelectWrapperProps> = ({
  size,
  ...props
}) => (
  <SelectWrapper {...{ size }}>
    <SelectInput {...props} />
  </SelectWrapper>
);
export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.tsx